const OSS = require('ali-oss');
function client() {
    //配置阿里云的参数
    return  new OSS({



        region: 'oss-cn-shenzhen',                                                      //地域
        endpoint: 'oss-cn-shenzhen.aliyuncs.com',                                       //访问域名
        accessKeyId: 'LTAImprdE9EHpp0j',                                               //标识用户ID
        accessKeySecret: 'hRjSeqJgBn8OIfvo9osS5jyPYyeGmN',                             //用户验证签名密钥
        bucket: 'ganxie',                                                   //存储空间
        //accessKeyId: 'LTAI4FmM2VzMKGYo8rWMRrwa',                                               //标识用户ID
        //accessKeySecret: 'q6MpqNBDNMdqoeNJvehkRoomvHyZrd',                             //用户验证签名密钥
        //bucket: 'lovebuc',
        secure: true

    })

}
export{client}



// WEBPACK FOOTER //
// ./src/assets/js/ali-oss-util.js